<template>
  <v-container class="py-0">
    <v-row>
      <v-col>
        <div v-intersect="handleIntersect" class="display-1 font-weight-normal mb-6 text-center">
          Essa etapa foi desativada, vá para a próxima etapa.
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EtapaDesativada',

    emits: ['intersect'],

    methods: {
      handleIntersect(entries) {
        if (entries[0].isIntersecting) {
          // Emitir evento quando o elemento estiver visível
          this.$emit('intersect');
        }
      }
    }
  };
</script>
